import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactElement;
  allowedRoles?: ('admin' | 'admin_medical_facility')[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);

  if (!isAuthenticated) {
    // check current path, if valid /facility -> redirect to /login else redirect to /admin/login
    if (window.location.pathname.includes('/facility') || window.location.pathname == '/login') {
      return <Navigate to="/login" replace />;
    } else {
      return <Navigate to="/admin/login" replace />;
    }
  }

  // If allowedRoles is specified, check if user's role is allowed
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // Redirect based on role
    if (user.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (user.role === 'admin_medical_facility') {
      return <Navigate to="/facility/dashboard" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

